import useAppContext from "../../hook/useAppContext"
import './header.css'

const Header = () => {

      const {data} = useAppContext()

      return (
            <header className="header_content">
                  <div className="container header_top flex">
                        <div className="logo flex">
                              <img src={data.logo.src} alt="xatMe" />
                        </div>
                  </div>
            </header>
      )
}

export default Header